export default "__VITE_ASSET__424b3098__"